export default function extractValueFromPriceString(priceString) {
  if (
    typeof priceString !== 'string' ||
    priceString.length === 0 ||
    !/\d/.test(priceString)
  ) {
    return null;
  }

  return Number(priceString.replace(/[^0-9.-]+/g, ''));
}
